import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from "../../ContextData/ContextData";

import "./Friends.scss";

const Friends = () => {
  const { userData } = useFormData();
  const [friendshipData, setFriendshipData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Extract columns (all planets)
  const columns = ["SUN", "MOON", "MARS", "MERCURY", "JUPITER", "VENUS", "SATURN"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/friendship",
          {
            params: {
             year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
            },
          }
        );

        const data = res.data.friendshipTable;

        // Convert object response into array format for rendering
        const transformData = (sectionData) =>
          Object.entries(sectionData).map(([planet, relations]) => ({
            planet,
            ...relations,
          }));

        setFriendshipData({
          "Permanent Friendship": transformData(data.permanent),
          "Temporal Friendship": transformData(data.temporal),
          "Five-fold Friendship": transformData(data.fiveFold),
        });
      } catch (error) {
        console.error("Error fetching friendship data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p className="loading">Loading friendship data...</p>;

  if (!friendshipData)
    return <p className="error">Failed to load friendship data.</p>;

  return (
    <div className="friends-container">
      <InnerNav />
      <div className="friends-content">
        <h1>Friendship Table</h1>

        {Object.keys(friendshipData).map((section, idx) => (
          <div key={idx} className="friends-section">
            <h2>{section}</h2>
            <div className="friends-table">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    {columns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {friendshipData[section].map((row, i) => (
                    <tr key={i}>
                      <th>{row.planet}</th>
                      {columns.map((col) => (
                        <td key={col}>{row[col]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Friends;
